/* ============================================================
   listicle-v3 — behaviours re-implemented from the Claude Design export
   (its own script was read, then discarded). Namespace: lpl3.
     1. Evergreen countdown in the offer bar: counts down from the section's
        minutes, restarts at zero. The end time survives a reload within the
        tab session (sessionStorage, guarded).
     2. Review carousel: previous / next scroll one card (card width + gap),
        arrow keys when the track has focus, smooth unless the visitor asks
        for reduced motion.
   Rebinds on shopify:section:load so the theme editor never double-binds.
   ============================================================ */
(function () {
  'use strict';
  var BOUND = 'lpl3Bound';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initTimer(el) {
    if (el.dataset[BOUND]) return;
    el.dataset[BOUND] = '1';
    var mins = parseInt(el.getAttribute('data-minutes'), 10);
    if (!(mins > 0)) mins = 22;
    var span = mins * 60 * 1000;
    var key = 'lpl3-timer-' + mins;
    var end = 0;
    try { end = parseInt(window.sessionStorage.getItem(key), 10) || 0; } catch (e) { end = 0; }
    var hh = el.querySelector('[data-lpl3-hh]');
    var mm = el.querySelector('[data-lpl3-mm]');
    var ss = el.querySelector('[data-lpl3-ss]');
    function tick() {
      var now = Date.now();
      if (!end || end <= now) {
        end = now + span;
        try { window.sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      var left = Math.max(0, Math.round((end - now) / 1000));
      if (hh) hh.textContent = pad(Math.floor(left / 3600));
      if (mm) mm.textContent = pad(Math.floor((left % 3600) / 60));
      if (ss) ss.textContent = pad(left % 60);
    }
    tick();
    el._lpl3Timer = window.setInterval(tick, 1000);
  }

  function initCarousel(root) {
    if (root.dataset[BOUND]) return;
    root.dataset[BOUND] = '1';
    var track = root.querySelector('[data-lpl3-track]');
    if (!track) return;
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    var prev = root.querySelector('[data-lpl3-prev]');
    var next = root.querySelector('[data-lpl3-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
  }

  function init(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-lpl3-timer]'), initTimer);
    Array.prototype.forEach.call(s.querySelectorAll('[data-lpl3-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-lpl3-timer]'), function (el) {
      if (el._lpl3Timer) window.clearInterval(el._lpl3Timer);
    });
  });
})();
